import generate from './generate.es.js';
export { default as generate } from './generate.es.js';

const functionalColors = {
    primary: '#ee112e',
    secondary: '#0674e8',
    link: '#1990ff',
    pending: '#ffa940',
    success: '#43da71',
    error: '#da4343',
};
let presetPalettes = {};
Object.keys(functionalColors).forEach((key) => {
    presetPalettes = Object.assign(Object.assign({}, presetPalettes), generate(functionalColors[key], key));
});
const themeColor = Object.assign({ white: '#FFFFFF', tableHeader: '#F8F8FC', background: '#F3F3F7', divider: '#E4E5F0', disable: '#DCDEE9', border: '#BCBFD6', placeholder: '#A7ABC3', textSecondary: '#82869E', textPrimary: '#434657', textTitle: '#1B1D29', black: '#000000', primary50: '', primary100: '', primary200: '', primary500: '', primary600: '', primary700: '', secondary50: '', secondary100: '', secondary200: '', secondary500: '', secondary600: '', secondary700: '', link50: '', link100: '', link200: '', link500: '', link600: '', link700: '', pending50: '', pending100: '', pending200: '', pending500: '', pending600: '', pending700: '', success50: '', success100: '', success200: '', success500: '', success600: '', success700: '', error50: '', error100: '', error200: '', error500: '', error600: '', error700: '' }, presetPalettes);

export { themeColor };
